import {createElement, Component, PropTypes} from 'rlink-react';
/**
 * @deprecated Temporary compatibility module - remove ASAP. Use below components directly.
 */

export {default as ContentDownload} from 'rlink-repos/components/ContentDownload';
export {default as ContentImg} from 'rlink-repos/components/ContentImg';
export {default as Picture} from 'rlink-repos/components/Picture';



// WEBPACK FOOTER //
// ./lib/rlink-repos/content-components.jsx